var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-overlay"},[_c(_setup.SvgIcon,{staticClass:"loading",attrs:{"icon":_setup.LoadingScheduleIcon}}),_c('span',{staticClass:"loading-text"},[_vm._v(_vm._s(_setup.t('Entering the room now...')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }